import script from "./SideBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideBar.vue?vue&type=script&lang=ts&setup=true"

import "./SideBar.vue?vue&type=style&index=0&id=00cf8302&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\git\\git\\chess-com-frontend-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00cf8302"]])

export default __exports__